import DeviceBulkConfigContainer from '~modules/devices/containers/DeviceBulkConfigContainer';
import dashboardWrapper from '~wrappers/dashboard';

export default dashboardWrapper(DeviceBulkConfigContainer);
